import clsx from "clsx";
import { SwitcherItemProps } from "./types";

export const SwitcherItem = ({
  variant,
  isActive,
  isDisabled,
  label,
  onClick,
  itemClassName,
  activeItemClassName,
}: SwitcherItemProps) => {
  const variantClasses =
    variant === "segmented"
      ? clsx(
          "flex-1 rounded-md px-3 py-1.5",
          isActive
            ? clsx(
                "bg-white text-blue-700 shadow-sm",
                activeItemClassName ?? "font-medium",
              )
            : "text-gray-500 hover:text-gray-700",
        )
      : isActive
        ? clsx("text-blue-700", activeItemClassName ?? "font-semibold")
        : "text-gray-500 hover:text-blue-700";

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={onClick}
      className={clsx(
        "relative transition-colors",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variantClasses,
        itemClassName,
      )}
    >
      {/* Reserve width for bold to prevent layout shift */}
      <span className="invisible font-semibold" aria-hidden="true">
        {label}
      </span>

      {/* Actual visible label */}
      <span className="absolute inset-0 flex items-center justify-center">
        {label}
      </span>
    </button>
  );
};
